// extracted by mini-css-extract-plugin
export default {"chevronLeft":"styles__chevronLeft__c8f68372c3cc8c0ced5e"};